import request from '~/utils/http';

export function getSession() {
  return request({
    url: 'api/Upload/GetSession',
    method: 'post',
    data: {}
  })
}


export function uploadFile(url, sendData) {
  return request({
    url: url,
    method: 'post',
    headers: { 
      "Content-Type": "multipart/form-data"
    },
    data: sendData
  })
}

export function deletedFile(sendData) {
  return request({
    url: "/api/Upload/Delete",
    method: 'post',
    data: sendData
  })
}

